// extracted by mini-css-extract-plugin
module.exports = {"appStoreBadge":"AppDownload_appStoreBadge__iDAFk","playStoreBadge":"AppDownload_playStoreBadge__34bRB"};